// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-6-a8C";
var _3 = "info__iata-ovbvW";
var _4 = "info__cities-Jmjmr";
var _5 = "arrivalInfo__itemLabel-3GA8Z";
var _6 = "info__time-bno4G";
var _7 = "arrivalInfo__itemValue-OSnLs";
export { _1 as "__esModule", _2 as "header", _3 as "info__iata", _4 as "info__cities", _5 as "arrivalInfo__itemLabel", _6 as "info__time", _7 as "arrivalInfo__itemValue" }
export default { "__esModule": _1, "header": _2, "info__iata": _3, "info__cities": _4, "arrivalInfo__itemLabel": _5, "info__time": _6, "arrivalInfo__itemValue": _7 }
